import React from 'react';
import { css } from '@emotion/react';

// === Styles === ///
import styled from '@emotion/styled';
import { breakpoints, respondFrom, respondTo } from '@styles';

const ImageFullWrapper = styled.div`
  width: 100%;

  img {
    display: none;
    max-width: none;
    width: 100%;
    margin: auto;
    ${respondFrom(
      breakpoints.md,
      css`
        display: block;
      `
    )}
  }

  .mobile {
    display: none;
    ${respondTo(
      breakpoints.md,
      css`
        display: block;
      `
    )}
  }
`;

interface ImageFullProps {
  imageDesktop: string;
  imageMobile?: string;
  alt: string;
  title?: string;
}

const ImageFull = ({ imageDesktop, imageMobile, alt, title }: ImageFullProps) => {
  return (
    <ImageFullWrapper className="image-full">
      <img src={imageDesktop} alt={alt} title={title} />
      <img
        className="mobile"
        src={imageMobile && imageMobile !== '' ? imageMobile : imageDesktop}
        alt={alt}
        title={title}
      />
    </ImageFullWrapper>
  );
};

export default ImageFull;
